<script setup lang="ts">
import InputText from 'primevue/inputtext';

const { rounded } = defineProps<{
  rounded?:boolean
}>()
</script>

<template>
<input-text :pt="{root:{
  class:'input-text',
  style:{
    borderRadius:rounded ? '40px' : '8px',
  }
}}" ></input-text>
</template>

<style scoped>


</style>